import colorPalette from '../color-palette';

export default {
  MuiAccordion: {
    root: {
      '&:before': {
        content: 'none',
      },
      '&$expanded': {
        margin: 0,
        color: colorPalette.text.primary,
      },
      boxShadow: 'none',
    },
  },
};
